"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _intl = require("../../../intl");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Row = /*#__PURE__*/(0, _styledComponents["default"])(_core.Grid).withConfig({
  displayName: "RateCardTableHead__Row"
})(["", ""], function (_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      palette = _ref$theme.palette;
  return (0, _styledComponents.css)(["padding:", ";background-color:", ";"], spacing(2, 2, 1, 2), palette.grey[50]);
});
var HeadingText = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).attrs({
  variant: 'body1'
}).withConfig({
  displayName: "RateCardTableHead__HeadingText"
})(["font-weight:bold;"]);
var LastGridItem = /*#__PURE__*/(0, _styledComponents["default"])(_core.Grid).withConfig({
  displayName: "RateCardTableHead__LastGridItem"
})(["text-align:end"]);

var RateCardTableHead = function RateCardTableHead(_ref2) {
  var type = _ref2.type;
  var isExpense = type === 'expense-rate-card';
  return _react["default"].createElement(Row, {
    container: true
  }, _react["default"].createElement(_core.Grid, {
    item: true,
    xs: isExpense ? 6 : 8
  }, _react["default"].createElement(HeadingText, null, _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.globalTable.headerTitle"
  }))), _react["default"].createElement(_core.Grid, {
    item: true,
    xs: isExpense ? 3 : 4
  }, _react["default"].createElement(HeadingText, null, _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.globalTable.headerRate"
  }))), isExpense && _react["default"].createElement(LastGridItem, {
    item: true,
    xs: 3
  }, _react["default"].createElement(HeadingText, null, _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.globalTable.headerMarkup"
  }))));
};

var _default = RateCardTableHead;
exports["default"] = _default;